import styled from 'styled-components'
import {Link} from '@modifi/router'
import {airBlue, backgroundColor, semiDarkGray} from '@modifi/colors'
import {NextIcon, Regular} from '@modifi/ui'

export const NavigationItemContainer = styled.li<{root: boolean}>`
  list-style: none;
  padding: 0;
  margin: 0;

  ${({root}): string => (root ? 'margin-bottom: 8px;' : 'margin-bottom: 4px;')}
`

export const SelectOption = styled(NextIcon)`
  color: ${airBlue};
  margin-right: 8px;
  transition: transform 200ms;
`

export const MenuLink = styled(Link)<{hasChildMatch?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-decoration: none;
  transition: transform 200ms ease;
  position: relative;
  padding-right: 12px;
  height: 48px;

  &:hover {
    background: ${backgroundColor};
    outline: 0;
  }

  .open > & {
    ${SelectOption} {
      transform: rotate3d(0, 0, 1, 90deg);
    }
  }

  ${({hasChildMatch}): string => (hasChildMatch ? 'font-weight: 600;' : '')}

  .active > & {
    font-weight: 600;
    background: ${backgroundColor};
    outline: 0;

    span {
      color: ${airBlue};
    }
  }

  .disabled > & {
    background-color: transparent;
    cursor: not-allowed;
  }
`

export const LabelWrapper = styled.div<{level: number}>`
  overflow: hidden;
  display: flex;
  align-items: center;
  flex: 1;
  ${({level}): string => `padding: 0 16px 0 ${20 + level * 28}px;`}
  & > * {
    flex-shrink: 0;
  }
`

export const Label = styled(Regular)<{hasIcon: boolean}>`
  white-space: nowrap;
  overflow: hidden;
  margin-left: 10px;
  margin-right: 10px;
  text-overflow: ellipsis;

  ${({hasIcon}): string =>
    hasIcon ? `display: flex; align-items: center; color: ${airBlue};` : ''}
  svg {
    margin-right: 10px;
  }

  .disabled & {
    color: ${semiDarkGray};
  }
`
